import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, namespace, State} from 'vuex-class';
import {
  EntityServiceTransaction,
  FilterServiceTransaction, ServiceTransactionInitState
} from '@/store/service-transaction/service-transaction.types';
import {MemberInitState} from '@/store/member/member.types';
import moment from 'moment';
import {FormValidate} from '@/services/form-validate';
import {Toast} from '@/store/toast/toast.types';
import {AxiosResponse} from 'axios';
import {Helper} from '../../../util/helper';

@Component({
  components: {}
})
export default class SelectTransactionComponent extends Vue {
  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @Action('_getServiceTransactionByMemberId', {namespace: 'serviceTransaction'})
  public getServiceTransactionByMemberId!: (filter?: FilterServiceTransaction) => Promise<any>
  @Action('_generateCode', {namespace: 'serviceTransaction'})
  public generateCode!: (selectTransaction: FilterServiceTransaction) => Promise<AxiosResponse>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;

  selectTransaction: string | null = null;

  public filterServiceTransaction = {} as FilterServiceTransaction;
  public stList: EntityServiceTransaction[] = [{
    subService: {
      service: {}
    }
  }] as EntityServiceTransaction[];

  public lib: Helper = new Helper();
  public test: any = {};
  public customizeOptions: { id: string, display: string }[] = [];

  async mounted() {
    let {id} = this.$route.query;
    if(id !== undefined) {
      this.selectTransaction = id as string;
    }
    await this.getServiceTransactionByMemberId();
    // this.test = this.serviceTransactionInitState.serviceTransaction[0];
    this.stList = this.serviceTransactionInitState.serviceTransactions;
    this.customizeOptions = this.stList.map((st) => {
      return {
        id: st.id || '',
        display: `${st.subService.service.serviceName} -> ${st.subService.name} | ${this.lib.formatDateTimeThai(st.serviceDate)} `
      }
    })
  }

  serviceTransactionChange() {
    console.log('DEBUG: serviceTransactionChange');
  }

  async confirmServiceTransaction() {

    let forms = document.getElementsByClassName('paymentSelectForm');
    let valid = FormValidate.validate(forms);
    if (!valid) {
      this.Toast({
        heading: '!',
        message: 'กรุณากรอกข้อมูลตามที่กำหนด',
        type: 'danger'
      }).then();
      return;
    }
    this.filterServiceTransaction.id = this.selectTransaction || '';
    let res = await this.generateCode(this.filterServiceTransaction);
    if (res.status === 500) {
      this.Toast({
        heading: '!',
        message: 'เกิดข้อผิดพลาดกรุณาตรวจสอบข้อมูลแล้วลองใหม่อีกครั้ง',
        type: 'danger'
      }).then();
      return;
    }
    console.log('DEBUG: confirmServiceTransaction');

    this.Toast({
      heading: '!',
      message: 'ดำเนินการสำเร็จ',
      type: 'success'
    }).then();
    this.$router.push({
      path: '/payment-code-generated',
      query: {
        id: this.selectTransaction
      }
    }).then()
  }
}


